// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__29hGT","fullscreen":"spinner_fullscreen__2kqRZ","single":"spinner_single__2lJRz","fullbody":"spinner_fullbody__3-GuM"};